module.exports = __webpack_public_path__ + "fonts/Roboto-300.fc84e998.ttf";